const Strings = {
  HIDE_COMMENTS: 'Göm kommentarer',
  APARTMENT: 'Lägenhet',
  SHOW_ALL_COMMENTS: 'Visa alla kommentarer',
  THE_BOARD: 'Styrelsen',
  COMMENTS: 'Kommentarer',
  COMMENT: 'Kommentar',
  LIKE: 'Gilla',
  MAKE_COMMENT: 'Kommentera',
  MISSING_COMMENT_HEADER: 'Kommentar saknas',
  MISSING_COMMENT: 'Ingen kommentar har skrivits in, var god försök igen.',
  OK: 'Okej',
  REQUEST_REMOVE_POST: 'Ta bort nyhet',
  REQUEST_REMOVE_POST_INFO:
    'Är du säker på att du vill ta bort nyheten? Detta kan inte göras ogjort.',
  YES: 'Ja',
  NO: 'Nej',
  REQUEST_REMOVE_COMMENT: 'Ta bort kommentar',
  REQUEST_REMOVE_COMMENT_INFO:
    'Är du säker på att du vill ta bort kommentaren? Detta kan inte göras ogjort.',
  NO_POSTS: 'Det finns inga nyheter.',
  NOT_AVAILABLE: 'Inte tillgängligt'
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/containers/FeedItems/strings.js